<template lang="pug">
.home
  aside.aside
    .nav
      .system-name(@click='$router.push("/")') 棋盘州大桥
        span 除湿数据采集与监视控制系统
      .nav-bar
        .nav-buttom
          router-link(to='/qipanzhou/gasClamp') 全桥实时数据
          router-link(to='/qipanzhou/anchorRoom') 锚室
          router-link(to='/qipanzhou/mainCable') 主缆
          router-link(to='/qipanzhou/saddleRoom') 鞍室
          router-link(to='/qipanzhou/steelBoxDehumidifier/huangshi') 黄石中跨箱梁
          router-link(to='/qipanzhou/steelBoxDehumidifier/huanggang') 黄冈中跨箱梁
          router-link(to='/qipanzhou/steelBoxSideSpan/upstream') 南边跨箱梁
          router-link.same-line(to='/qipanzhou/bridgeImg')
            p 全桥除湿
            p 总体布置图
          router-link(to='/qipanzhou/dataHistory?bridgeId=2003ac27-8590-4b54-9022-0a9c92e809c7&scenarioId=TBD') 数据历史
  TimeBlock.time-block(bridgeName='HUBEI')
</template>

<script>
import TimeBlock from '@/components/TimeBlock';

export default {
  name: 'Index',
  components: {
    TimeBlock,
  },
  data() {
    return {
      timer: null,
      bridgeId: '2003ac27-8590-4b54-9022-0a9c92e809c7',
      historyScenarioList: [],
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      this.checkAuth();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  computed: {
   
  },
  methods: {
    checkAuth() {
      this.$http.get('/auth/LoginInfo').then((res) => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
  height: 100%;
  position: relative;
  background: url('../../assets/image/qipanzhou/qipanzhou.jpg') center no-repeat;
  background-size: cover;

  .time-block {
    position: absolute;
    top: 100px;
    right: 150px;
  }

  .aside {
    position: relative;
    width: 250px;
    height: 100%;
    color: #fff;
    min-width: 260px;
    text-align: center;
    box-shadow: 0 0 30px 0 #000;
    overflow: hidden;
    box-sizing: border-box;
    background: url('../../assets/image/qipanzhou/qipanzhou1.jpg') center
      no-repeat fixed;
    background-size: cover;

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      background: transparent;
    }

    ::-webkit-scrollbar-corner {
      background: transparent;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background-color: #84a4c2;
    }

    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
      border-radius: 0;
      background-color: transparent;
    }

    .nav {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      z-index: 1;

      a {
        display: block;
        width: 58%;
        height: 48px;
        margin: 0 auto 20px auto;
        border: none;
        line-height: 48px;
        border-radius: 5px;
        color: #4b4e50;
        background: #cadce9;
        cursor: pointer;
        text-decoration: none;

        &.same-line {
          display: flex;
          flex-direction: column;
          justify-content: center;
          line-height: 18px;
        }

        p {
          margin: 0;
        }

        &:hover {
          color: #fff;
          background: #33a2f5;
        }
      }

      .system-name {
        height: 75px;
        font-weight: 700;
        font-size: 40px;
        margin: 75px 0;
        cursor: pointer;
        span {
          display: block;
          font-size: 18px;
        }
      }

      .nav-bar {
        height: calc(100% - 250px);
        overflow-y: auto;
      }
    }
  }
}
</style>
